import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { useGlobalStore } from '@/stores';

export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMap',
  setup(__props) {

const globalStore = useGlobalStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("iframe", {
    src: (_unref(globalStore).organization.googleMapSource as string),
    width: "100%",
    height: "450",
    style: {"border":"0"},
    allowfullscreen: "true",
    loading: "lazy",
    referrerpolicy: "no-referrer-when-downgrade"
  }, null, 8, _hoisted_1))
}
}

})